import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class WorkUnitPaymentServices {
  async getByAll(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/work-unit/`, {
        headers: { 'authentication-token': getJWT()! },
        params: {
          limit: 999,
        }
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
}
export const workUnitPaymentServices = new WorkUnitPaymentServices()
